module.exports = __webpack_public_path__ + "static/img/letftop.6632457.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/letftop.png
// module id = NATi
// module chunks = 1